export const LadderIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.5"
        x="9.81006"
        y="4.44971"
        width="12.38"
        height="4"
        fill="#FFAB00"
      />
      <rect
        opacity="0.5"
        x="9.81006"
        y="14.5208"
        width="12.38"
        height="4"
        fill="#FFAB00"
      />
      <rect
        opacity="0.5"
        x="9.81006"
        y="24.5913"
        width="12.38"
        height="4"
        fill="#FFAB00"
      />
      <rect
        opacity="0.4"
        x="9.81006"
        y="14.5208"
        width="1.75081"
        height="4"
        fill="#FFAB00"
      />
      <rect
        opacity="0.4"
        x="9.81006"
        y="4.44971"
        width="1.75081"
        height="4"
        fill="#FFAB00"
      />
      <rect
        opacity="0.4"
        x="9.81006"
        y="24.5913"
        width="1.75081"
        height="4"
        fill="#FFAB00"
      />
      <rect
        opacity="0.8"
        x="5.81006"
        y="32"
        width="32"
        height="4"
        rx="2"
        transform="rotate(-90 5.81006 32)"
        fill="#FFAB00"
      />
      <path
        d="M7.81006 32C8.91463 32 9.81006 31.1046 9.81006 30L9.81006 2C9.81006 0.895431 8.91463 4.82823e-08 7.81006 0C7.81006 4.14987 7.81006 7.97327 7.81006 9.07784V27.3817C7.81006 28.4863 7.81006 29.572 7.81006 32Z"
        fill="#FFAB00"
      />
      <rect
        opacity="0.8"
        x="22.1899"
        y="32"
        width="32"
        height="4"
        rx="2"
        transform="rotate(-90 22.1899 32)"
        fill="#FFAB00"
      />
      <path
        d="M24.1899 32C25.2945 32 26.1899 31.1046 26.1899 30L26.1899 2C26.1899 0.895431 25.2945 4.82823e-08 24.1899 0C24.1899 4.14987 24.1899 7.97327 24.1899 9.07784V27.3817C24.1899 28.4863 24.1899 29.572 24.1899 32Z"
        fill="#FFAB00"
      />
    </svg>
  );
};
